module.exports = __webpack_public_path__ + "img/x2048.14872525.png";